import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ControlsModule } from 'app/controls/controls.module';
import { ImageSelectionDirectiveModule } from 'app/image-selection.directive';
import { MatModule } from 'core/material/mat.module';
import { TranslationModule } from 'core/translation/translation.module';
import { ActionBarComponent
       } from './placeholder/overlays/action-bar/action-bar.component';
import { ActionBarDirective
       } from './placeholder/overlays/action-bar/action-bar.directive';
import { PlaceholderContentService
       } from './placeholder/placeholder-content.service';
import { PlaceholderService } from './placeholder/placeholder.service';
import { StageComponent } from './stage.component';
import { StageService } from './stage.service';
import { SVGValidationService } from './svg-validation.service';


@NgModule({
  imports: [
    CommonModule,
    ControlsModule,
    FormsModule,
    MatModule,
    ImageSelectionDirectiveModule,
    TranslationModule,
  ],
  declarations: [
    ActionBarComponent,
    ActionBarDirective,
    StageComponent,
  ],
  exports: [
    StageComponent,
  ],
  providers: [
    StageService, SVGValidationService, PlaceholderService,
    PlaceholderContentService
  ]
})
export class StageModule { }
